import { useDispatch, useSelector } from 'react-redux'
import { checks } from '../../../state/slices/formSlice'
import React from 'react'

const CheckBox = (props) => {
    let modulo = props.modulo
    let index = props.index
    const dispatch = useDispatch()
    const modo = useSelector((state) => state.addForm.modo)
    const ficha = useSelector((state) => state.addForm.ficha)

    const estilo = {
        principal: {
            display: "block", textAlign: "left", marginRight: props.marginR
        },
        label: {
            color: "#484848", marginLeft: "0.8vw", position: "relative", top: "-0.2vh"
        }
    }

    return (
        <>{RenderInput()}</>
    )

    function RenderInput() {
        let object = []
        let bool
        const inputId = `checkbox-${props.grupo}-${props.texto}-${index}`
        if (ficha[modulo] && ficha[modulo][index]) {
            var valor = true
            if(!ficha[modulo][index][props.grupo]) bool = -1
            else bool = ficha[modulo][index][props.grupo].indexOf(props.texto)
        }
        if (bool !== -1) {
            var checked = true
        }
        if (!valor) {
            object.push(
                <div style={estilo.principal}>
                    <input type="checkbox" id={inputId} name={props.grupo} value={props.texto}
                        onChange={e => dispatch(checks({ e, modulo, index }))} />
                    <label style={estilo.label} htmlFor={inputId}>{props.texto}</label>
                </div>
            )
        }
        else if (valor && modo === "view") {
            object.push(
                <div style={estilo.principal}>
                    <input type="checkbox" id={inputId} style={{ pointerEvents: "none" }} checked={checked} />
                    <label style={estilo.label} htmlFor={inputId}>{props.texto}</label>
                </div>
            )
        }
        else {
            object.push(
                <div style={estilo.principal}>
                    <input type="checkbox" id={inputId} name={props.grupo} value={props.texto}
                        defaultChecked={checked}
                        onChange={e => dispatch(checks({ e, modulo, index }))} />
                    <label style={estilo.label} htmlFor={inputId}>{props.texto}</label>
                </div>
            )
        }
        return object
    }
}

export default CheckBox